
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("br2f9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $984af54bc824685d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $984af54bc824685d$export$2e2bcd8739ae039 = {
    'navigation.global-shortcuts.all-sites': "V\u0161echny weby",
    'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': "Zav\u0159\xedt",
    'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': "(moment\xe1ln\u011B nedostupn\xe9)",
    'navigation.global-shortcuts.sites': 'Weby {productName}'
};

});


//# sourceMappingURL=cs.c63882fc.js.map
